import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorFallback from '../ErrorFallback'

function PageNotFound(props) {
  const { t } = useTranslation()
  return <ErrorFallback title={t('errorPage.pageNotFound')} subTitle={t('errorPage.pageNotFoundSubTitle')} />
}

export default PageNotFound
